export const locale = {
    lang: "es",
    data: {
        DASHBOARD: {
            Title: "Control Center",
            SwitchViews: "Switch View",
            Done: "Cerrar",
            EventStream: "Events",
            KioskMode: "Modo Kiosko",
            KioskModeMessage: "El modo Kiosko funciona mejor en pantalla completa, quieres ir a pantalla completa?",
        },
        DEVICES: {
            ConnectedDevices: "Dispositivos conectados",
            Connected: "Connectados",
            Total: "Total",
        },
        FIELD: {
            sound_pressure_level: "Nivel Ruido (dBA)",
            sound_pressure_level_c: "Nivel Ruido (dBC)",
            sound_pressure_level_1m: "Nivel Ruido (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Nivel Ruido (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 segundos (dBA)",
            rolling_5s_c: "Rolling 5 segundos (dBC)",
            rolling_5: "Rolling 5 minutos (dBA)",
            rolling_5_c: "Rolling 5 minutos (dBC)",
            rolling_30: "Rolling 30 minutos (dBA)",
            rolling_30_c: "Rolling 30 minutos (dBC)",
            battery: "Batería",
            power_supply_status: "Fuente Alimentación",
            spectrum_13_octave: "Espectro 1/3 Octava",
            spectrum_13_octave_1m: "Espectro 1/3 Octava (1 min)",
            temperature: "Temperatura Ext.",
            overload: "Sobrecarga",
            underrange: "Underrange",
            wifi_signal_level: "Señal WiFi",
            cellullar_signal_level: "Señal Cellular",
            free_storage: "Espacio Libre",
        },
        SIDEBAR: {
            Views: "Vistas",
            Delete: "Estas seguro que quieres borrarlo ?",
            AddView: "Añadir Vista",
        },
    },
};
